import { render, staticRenderFns } from "./ChoosePackage.vue?vue&type=template&id=3e361c98&scoped=true"
import script from "./ChoosePackage.vue?vue&type=script&lang=ts"
export * from "./ChoosePackage.vue?vue&type=script&lang=ts"
import style0 from "./ChoosePackage.vue?vue&type=style&index=0&id=3e361c98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e361c98",
  null
  
)

export default component.exports